import { PageContainer } from '@components/PageContainer';
import { Card } from '@gurupay/gp-ui-library';
import { useAuth } from '@hooks/useAuth';
import { EMPTY_VALUE } from '@pages/settings/profile/utils';
import { parseUserAgent } from '@utils/userAgent.ts';
import { formatUtcDate } from '@utils/utils';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const LoginActivity = () => {
	const { t } = useTranslation('', { keyPrefix: 'loginActivity' });
	const { session } = useAuth();
	const formattedDate = useMemo(
		() => session?.authenticated_at && formatUtcDate(session?.authenticated_at),
		[session?.authenticated_at],
	);

	const { browser, os, version, device } = parseUserAgent(
		session?.devices?.[0]?.user_agent ?? '',
	);

	return (
		<PageContainer backUrl="/settings" title={t('title')}>
			<Card className="max-w-[512px]" title={t('header')}>
				<div className="flex flex-col gap-space-2">
					<dt className="text-sm-medium text-neutral-600">{t('loggedIn')}</dt>
					<dd className="text-sm-bold">{formattedDate}</dd>
				</div>
				<div className="flex flex-col gap-space-2">
					<dt className="text-sm-medium text-neutral-600">{t('browser')}</dt>
					<dd className="text-sm-bold">{browser ?? EMPTY_VALUE}</dd>
				</div>
				<div className="flex flex-col gap-space-2">
					<dt className="text-sm-medium text-neutral-600">{t('browserVersion')}</dt>
					<dd className="text-sm-bold">{version ?? EMPTY_VALUE}</dd>
				</div>
				<div className="flex flex-col gap-space-2">
					<dt className="text-sm-medium text-neutral-600">{t('os')}</dt>
					<dd className="text-sm-bold">{os ?? EMPTY_VALUE}</dd>
				</div>
				<div className="flex flex-col gap-space-2">
					<dt className="text-sm-medium text-neutral-600">{t('device')}</dt>
					<dd className="text-sm-bold">{device ?? EMPTY_VALUE}</dd>
				</div>
				<div className="flex flex-col gap-space-2">
					<dt className="text-sm-medium text-neutral-600">{t('ip')}</dt>
					<dd className="text-sm-bold">{session?.devices?.[0]?.ip_address ?? ''}</dd>
				</div>
			</Card>
		</PageContainer>
	);
};
